<template>
    <div class="main">
        <c-panel title="QUADRO DE HORÁRIOS — GERAÇÃO EM LOTE" titleIcon="fas fa-layer-group">

            <el-alert type="info" :closable="false" class="u-mb-15"
                title="Aplica o mesmo desenho de quadro a várias turmas de uma vez."
                description="Cada turma é gravada de forma independente: se uma tiver conflito, as demais continuam. Turmas que já possuem quadro só são regravadas se você marcar a substituição."></el-alert>

            <!-- ==================== 1 · TURMAS ==================== -->
            <h4 class="passo">1 · Escolha as turmas</h4>

            <el-form label-position="top" @submit.native.prevent>
                <el-row :gutter="10" class="u-mb-10">
                    <el-col :xs="24" :sm="7">
                        <el-form-item label="Escola" class="u-mb-0">
                            <el-select v-model="instituicaoId" filterable style="width: 100%;" @change="carregarTurmas">
                                <el-option v-for="i in instituicoes" :key="i.id" :value="i.id" :label="i.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="5">
                        <el-form-item label="Período letivo" class="u-mb-0">
                            <el-select v-model="periodoId" style="width: 100%;" @change="carregarTurmas">
                                <el-option v-for="p in periodos" :key="p.id" :value="p.id" :label="p.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="7">
                        <el-form-item label="Curso (opcional)" class="u-mb-0">
                            <el-select v-model="filtro.curso_id" filterable clearable placeholder="Todos" style="width: 100%;" @change="carregarTurmas">
                                <el-option v-for="c in cursos" :key="c.id" :value="c.id" :label="c.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="5">
                        <el-form-item label="Turno (opcional)" class="u-mb-0">
                            <el-select v-model="filtro.turno" clearable placeholder="Todos" style="width: 100%;" @change="carregarTurmas">
                                <el-option v-for="t in turnos" :key="t.v" :value="t.v" :label="t.l"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <el-alert v-if="avisoTurmas" type="warning" :closable="false" class="u-mb-10" :title="avisoTurmas"></el-alert>

            <div v-if="turmas.length" class="container-table u-mb-15">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 40px;">
                                <el-checkbox :value="todasMarcadas" @change="alternarTodas"></el-checkbox>
                            </th>
                            <th>Turma</th>
                            <th style="width: 110px;" class="u-text-center">Turno</th>
                            <th style="width: 110px;" class="u-text-center">Aulas/dia</th>
                            <th style="width: 190px;" class="u-text-center">Quadro atual</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="t in turmas" :key="t.id">
                            <td><el-checkbox v-model="selecionadas" :label="t.id">&nbsp;</el-checkbox></td>
                            <td>{{ t.nome }}</td>
                            <td class="u-text-center">{{ rotuloTurno(t.turno) }}</td>
                            <td class="u-text-center">{{ t.qtd_horarios || '—' }}</td>
                            <td class="u-text-center">
                                <el-tag v-if="t.ja_tem_quadro" size="mini" type="warning">{{ t.qtd_aulas_atual }} aula(s)</el-tag>
                                <span v-else class="sem">sem quadro</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- ==================== 2 · DESENHO ==================== -->
            <h4 class="passo">2 · Monte o desenho do quadro</h4>

            <el-alert type="info" :closable="false" class="u-mb-10"
                title="O professor é opcional aqui"
                description="Turmas diferentes normalmente têm professores diferentes no mesmo componente. Deixe em branco para gravar só o horário e montar o quadro docente depois."></el-alert>

            <el-form label-position="top" @submit.native.prevent>
                <el-row :gutter="10" class="u-mb-10">
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Dia da semana" class="u-mb-0">
                            <el-select v-model="novo.dia_semana" style="width: 100%;">
                                <el-option v-for="d in dias" :key="d.v" :value="d.v" :label="d.l"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="4">
                        <el-form-item label="Ordem da aula" class="u-mb-0">
                            <el-input-number v-model="novo.ordem_aula" :min="1" :max="20" controls-position="right" style="width: 100%;"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="9">
                        <el-form-item label="Componente curricular" class="u-mb-0">
                            <el-select v-model="novo.area_conhecimento_id" filterable placeholder="Selecione o componente" style="width: 100%;">
                                <el-option v-for="a in areas" :key="a.id" :value="a.id" :label="a.nome_area"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="5" class="u-text-right u-mt-25">
                        <el-button size="small" icon="el-icon-plus" :disabled="!novo.area_conhecimento_id" @click="adicionarSlot">ADICIONAR AULA</el-button>
                    </el-col>
                </el-row>
            </el-form>

            <div v-if="slots.length" class="container-table u-mb-15">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 140px;">Dia</th>
                            <th style="width: 110px;" class="u-text-center">Ordem</th>
                            <th>Componente</th>
                            <th style="width: 70px;"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(s, i) in slotsOrdenados" :key="i">
                            <td>{{ rotuloDia(s.dia_semana) }}</td>
                            <td class="u-text-center">{{ s.ordem_aula }}ª</td>
                            <td>{{ nomeArea(s.area_conhecimento_id) }}</td>
                            <td class="u-text-center">
                                <el-button type="danger" plain size="mini" icon="el-icon-delete" @click="removerSlot(s)"></el-button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <p v-else class="sem u-mb-15">Nenhuma aula no desenho ainda.</p>

            <!-- ==================== 3 · APLICAR ==================== -->
            <h4 class="passo">3 · Aplique</h4>

            <el-row :gutter="10" class="u-mb-15">
                <el-col :xs="24" :sm="14">
                    <el-checkbox v-model="substituir">
                        Substituir o quadro das turmas que já possuem um
                    </el-checkbox>
                    <div v-if="substituir && qtdComQuadroSelecionadas" class="alerta-substituir">
                        {{ qtdComQuadroSelecionadas }} turma(s) selecionada(s) terão o quadro atual apagado e regravado.
                    </div>
                </el-col>
                <el-col :xs="24" :sm="10" class="u-text-right">
                    <el-button v-if="podeEscrever" type="primary" icon="el-icon-magic-stick"
                        :disabled="!selecionadas.length || !slots.length" @click="confirmarAplicacao">
                        GERAR PARA {{ selecionadas.length }} TURMA(S)
                    </el-button>
                </el-col>
            </el-row>

            <!-- ==================== RESULTADO ==================== -->
            <div v-if="resultado">
                <el-alert :type="resultado.com_erro ? 'warning' : 'success'" :closable="false" class="u-mb-10"
                    :title="resultado.mensagem"></el-alert>

                <el-collapse v-model="abertos">
                    <el-collapse-item v-if="resultado.detalhe_aplicadas.length" title="Turmas geradas" name="ok">
                        <ul class="lista">
                            <li v-for="a in resultado.detalhe_aplicadas" :key="'a' + a.turma_id">
                                {{ a.turma }} — {{ a.slots_gravados }} aula(s)
                                <el-tag v-if="a.avisos && a.avisos.length" size="mini" type="warning">{{ a.avisos.length }} aviso(s)</el-tag>
                            </li>
                        </ul>
                    </el-collapse-item>
                    <el-collapse-item v-if="resultado.detalhe_ignoradas.length" title="Turmas ignoradas" name="ign">
                        <ul class="lista">
                            <li v-for="g in resultado.detalhe_ignoradas" :key="'g' + g.turma_id">
                                {{ g.turma }} — {{ g.motivo }}
                            </li>
                        </ul>
                    </el-collapse-item>
                    <el-collapse-item v-if="resultado.detalhe_erros.length" title="Turmas com erro" name="err">
                        <ul class="lista">
                            <li v-for="e in resultado.detalhe_erros" :key="'e' + e.turma_id">
                                <strong>{{ e.turma }}</strong> — {{ e.motivo }}
                            </li>
                        </ul>
                    </el-collapse-item>
                </el-collapse>
            </div>
        </c-panel>
    </div>
</template>

<script>
/**
 * ITEM 104 — geração do quadro de horários para várias turmas simultaneamente.
 *
 * Tela separada da de quadro por turma de propósito: aqui a unidade de trabalho é o
 * CONJUNTO de turmas, e o fluxo é outro (escolher turmas → montar desenho → aplicar).
 */
export default {
    name: 'QuadroHorarioLote',
    data () {
        return {
            instituicoes: [], periodos: [], cursos: [], areas: [],
            instituicaoId: null, periodoId: null,
            filtro: { curso_id: null, turno: null },
            turmas: [], selecionadas: [], avisoTurmas: null,
            slots: [], novo: { dia_semana: 1, ordem_aula: 1, area_conhecimento_id: null },
            substituir: false, resultado: null, abertos: ['err', 'ign'],
            dias: [
                { v: 1, l: 'Segunda-feira' }, { v: 2, l: 'Terça-feira' }, { v: 3, l: 'Quarta-feira' },
                { v: 4, l: 'Quinta-feira' }, { v: 5, l: 'Sexta-feira' }, { v: 6, l: 'Sábado' }
            ],
            turnos: [{ v: 0, l: 'Matutino' }, { v: 1, l: 'Vespertino' }, { v: 2, l: 'Noturno' }, { v: 4, l: 'Integral' }]
        }
    },
    computed: {
        podeEscrever () { return [0, 1, 3, 4, 5, 6, 7, 12].includes(parseInt(this.$store.state.user.tipo)) },
        todasMarcadas () { return this.turmas.length > 0 && this.selecionadas.length === this.turmas.length },
        slotsOrdenados () {
            return this.slots.slice().sort((a, b) => (a.dia_semana - b.dia_semana) || (a.ordem_aula - b.ordem_aula))
        },
        qtdComQuadroSelecionadas () {
            return this.turmas.filter(t => t.ja_tem_quadro && this.selecionadas.includes(t.id)).length
        }
    },
    mounted () {
        this.instituicoes = this.$store.state.instituicoes || []
        this.periodos = this.$store.state.periodos || []
        const inst = this.$store.state.config.instituicao
        this.instituicaoId = inst && inst.id ? inst.id : (this.instituicoes.length ? this.instituicoes[0].id : null)
        this.periodoId = this.$store.state.config.periodo ? this.$store.state.config.periodo.id : null
        this.carregarCursos()
        this.carregarAreas()
        this.carregarTurmas()
    },
    methods: {
        carregarCursos () {
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/curso/getAll`, this.$store.getters.getHeaderAuth)
                .then(r => { this.cursos = Array.isArray(r.data) ? r.data : (r.data.dados || []) })
                .catch(e => this.$store.commit('throwException', e))
        },
        carregarAreas () {
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/area-conhecimento/getAll`, this.$store.getters.getHeaderAuth)
                .then(r => { this.areas = Array.isArray(r.data) ? r.data : [] })
                .catch(e => this.$store.commit('throwException', e))
        },
        carregarTurmas () {
            this.turmas = []
            this.selecionadas = []
            this.avisoTurmas = null
            if (!this.instituicaoId || !this.periodoId) return
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/quadro-horario/turmasParaLote/${this.instituicaoId}/${this.periodoId}`,
                Object.assign({ params: this.filtro }, this.$store.getters.getHeaderAuth)
            ).then(r => {
                if (r.data && r.data.erro) { this.avisoTurmas = this.textoErro(r.data.erro); return }
                this.turmas = r.data.turmas || []
                this.avisoTurmas = r.data.aviso || null
            }).catch(e => this.$store.commit('throwException', e))
        },
        alternarTodas (marcar) {
            this.selecionadas = marcar ? this.turmas.map(t => t.id) : []
        },
        adicionarSlot () {
            const jaTem = this.slots.some(s => s.dia_semana === this.novo.dia_semana && s.ordem_aula === this.novo.ordem_aula)
            if (jaTem) {
                window.eventBus.$emit('alert', { msg: 'Já existe uma aula nesse dia e nessa ordem.', type: 'warning' })
                return
            }
            this.slots.push(Object.assign({}, this.novo))
            this.novo.ordem_aula = this.novo.ordem_aula + 1
        },
        removerSlot (s) {
            this.slots = this.slots.filter(x => !(x.dia_semana === s.dia_semana && x.ordem_aula === s.ordem_aula))
        },
        confirmarAplicacao () {
            const texto = this.substituir && this.qtdComQuadroSelecionadas
                ? `${this.qtdComQuadroSelecionadas} turma(s) terão o quadro APAGADO e regravado. Confirma?`
                : `Gerar o quadro para ${this.selecionadas.length} turma(s)?`
            this.$confirm(texto, 'Gerar quadro em lote',
                { confirmButtonText: 'Gerar', cancelButtonText: 'Cancelar', type: this.substituir ? 'warning' : 'info' })
                .then(() => this.aplicar()).catch(() => {})
        },
        aplicar () {
            this.resultado = null
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/quadro-horario/gerarEmLote`,
                {
                    turma_ids: this.selecionadas,
                    periodo_letivo_id: this.periodoId,
                    slots: this.slots,
                    substituir_existente: this.substituir
                },
                this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                this.resultado = r.data
                window.eventBus.$emit('alert', { msg: r.data.mensagem, type: r.data.com_erro ? 'warning' : 'success' })
                this.carregarTurmas()
            }).catch(e => this.$store.commit('throwException', e))
        },
        rotuloDia (v) { const d = this.dias.find(x => x.v === v); return d ? d.l : v },
        rotuloTurno (v) { const t = this.turnos.find(x => x.v === parseInt(v)); return t ? t.l : '—' },
        nomeArea (id) { const a = this.areas.find(x => x.id === id); return a ? a.nome_area : id },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
<style scoped>
.passo { margin: 18px 0 10px; padding-bottom: 6px; border-bottom: 1px solid #ebeef5; color: #303133; }
.sem { color: #909399; font-size: 12px; }
.lista { margin: 0; padding-left: 18px; font-size: 12px; }
.lista li { margin-bottom: 4px; }
.alerta-substituir { margin-top: 6px; font-size: 12px; color: #e6a23c; }
</style>
